<template>
    <div class="">
        <b-container class="dynamic-checkout-container">
            <b-row>
                <b-col cols="12" lg="8" class="scroll-section">
                    <div class="container pt-4">
                        <div class="d-flex my-3 checkout-font-color">
                            <h4>Secure Checkout</h4>
                        </div>
                        <div class="accordion-header-selected p-2 d-flex">
                            <h5 class="mt-2 mr-2">
                                <span class="badge badge-light">1</span>
                            </h5>
                            <h5 class="my-auto checkout-font-color">
                                Delivery
                            </h5>
                        </div>
                        <div class="customer-form my-3">
                            <div class="row my-2">
                                <div class="col-12 col-md-6">
                                    <label class="font-weight-bold checkout-font-color">First Name*</label>
                                    <b-form-input placeholder="Ex. Jane"></b-form-input>
                                </div>
                                <div class="col-12 col-md-6">
                                    <label class="font-weight-bold checkout-font-color">Last Name*</label>
                                    <b-form-input placeholder="Ex. Cooper"></b-form-input>
                                </div>
                            </div>
                            <div class="row my-2">
                                <div class="col-12 col-md-6">
                                    <label class="font-weight-bold checkout-font-color">Address*</label>
                                    <b-form-input placeholder="3124 Langtown Road, Mansfield"></b-form-input>
                                </div>
                                <div class="col-12 col-md-6">
                                    <label class="font-weight-bold checkout-font-color">Email*</label>
                                    <b-form-input placeholder="Example@gmail.com"></b-form-input>
                                </div>
                            </div>
                            <div class="row my-2">
                                <div class="col-12 col-md-6">
                                    <label class="font-weight-bold checkout-font-color">City*</label>
                                    <b-form-input placeholder="Mansfield"></b-form-input>
                                </div>
                                <div class="col-12 col-md-6">
                                    <label class="font-weight-bold checkout-font-color">Postal Code*</label>
                                    <b-form-input placeholder="44907"></b-form-input>
                                </div>
                            </div>
                        </div>
                        <div class="delivery-method p-4 rounded-lg my-4">
                            <div class="bg-white rounded-lg p-4">
                                <div class="d-flex">
                                    <p class="font-weight-bold checkout-font-color">Delivery Method</p>
                                    <p class="font-weight-bold ml-auto checkout-font-color">Shipping Cost</p>
                                </div>
                                <div class="p-2">
                                    <div 
                                        @click="selectPayment('standard')"
                                        :class="selected === 'standard' ? 'selected-radio' : ''"
                                        class="
                                            custom-delivery-radio 
                                            d-flex align-items-center 
                                            p-3 
                                            rounded-lg
                                            w-100
                                            my-2"
                                        >
                                            <div class="dot-border">
                                                <div :class="selected === 'standard' ? 'selected-dots' : 'select-dots'"></div>
                                            </div>
                                            <div class="text my-auto ml-2 checkout-font-color">Standard delivery with DHL</div>
                                            <div class="text my-auto ml-auto font-weight-bold checkout-font-color">€ 7.90</div>
                                    </div>
                                    <div 
                                        @click="selectPayment('same_day')"
                                        :class="selected === 'same_day' ? 'selected-radio' : ''"
                                        class="
                                            custom-delivery-radio 
                                            d-flex align-items-center 
                                            p-3 
                                            rounded-lg
                                            w-100
                                            my-2"
                                        >
                                            <div class="dot-border">
                                                <div :class="selected === 'same_day' ? 'selected-dots' : 'select-dots'"></div>
                                            </div>
                                            <div class="text my-auto ml-2 checkout-font-color">Same day delivery with DPD</div>
                                            <div class="text my-auto ml-auto font-weight-bold checkout-font-color">€ 15.90</div>
                                    </div>
                                    <div 
                                        @click="selectPayment('choose_date')"
                                        class="
                                            custom-delivery-radio  
                                            p-3
                                            w-100"
                                        :class="selected === 'choose_date' ? 'selected-radio-two' : 'rounded-lg my-2'"
                                        >
                                        <div class="d-flex align-items-center">
                                            <div class="dot-border">
                                                <div :class="selected === 'choose_date' ? 'selected-dots-two' : 'select-dots'"></div>
                                            </div>
                                            <div class="text my-auto ml-2 checkout-font-color">Choose delivery date</div>
                                            <div class="text my-auto ml-auto font-weight-bold checkout-font-color">€ 10.90</div>
                                        </div>
                                    </div>
                                    <transition name="slide-down">
                                        <div
                                            v-if="selected === 'choose_date'"
                                            class="
                                                radio-extension  
                                                px-3
                                                w-100
                                                mb-2"
                                        >
                                            <div class="d-flex align-items-center">
                                                <div class="dot-border-hidden">
                                                    <div class="hidden-dot"></div>
                                                </div>
                                                <div class="ml-2">
                                                    <div class="d-flex"> 
                                                        <div class="text my-auto mr-2 checkout-font-color">Delivered by <b>PostNL</b></div>
                                                        <img src="~@/assets/checkout/postnl-logo.svg" alt="">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row w-full py-3">
                                                <div class="col-1 my-auto">
                                                    <font-awesome-icon icon="arrow-left"/>
                                                </div>
                                                <div v-for="date in dates" @click="selectDate(date.id)" v-bind:key="date.id" class="col-2 bg-white w-100 px-1">
                                                    <div 
                                                        :class="selected_date === date.id ? 
                                                        'selected-radio-date-picker'
                                                        : 'radio-date-picker'" 
                                                        class="py-1 pt-3 rounded-lg"
                                                    >
                                                        <p class="text-center checkout-font-color">
                                                            <b>{{ date.date_day }}</b><br>
                                                            {{ date.month }}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div class="col-1 my-auto">
                                                    <font-awesome-icon icon="arrow-right"/>
                                                </div>
                                            </div>
                                        </div>
                                    </transition>
                                    <div 
                                        @click="selectPayment('pick_up')"
                                        class="
                                            custom-delivery-radio  
                                            p-3
                                            w-100"
                                        :class="selected === 'pick_up' ? 'selected-radio-two' : 'rounded-lg my-2'"
                                        >
                                        <div class="d-flex align-items-center">
                                            <div class="dot-border">
                                                <div :class="selected === 'pick_up' ? 'selected-dots-two' : 'select-dots'"></div>
                                            </div>
                                            <div class="text my-auto ml-2 checkout-font-color">Pickup at collection point</div>
                                            <div class="text my-auto ml-auto font-weight-bold checkout-font-color">€ 0.00</div>
                                        </div>
                                    </div>
                                    <transition name="slide-down">
                                        <div
                                            v-if="selected === 'pick_up'"
                                            class="
                                                radio-extension  
                                                px-3
                                                w-100
                                                mb-2"
                                        >
                                            <div class="d-flex align-items-center p-2">
                                                <collection-point></collection-point>
                                            </div>
                                        </div>
                                    </transition>
                                    <div class="mt-4">
                                        <button type="button" class="btn btn-primary continue-button w-100 checkout-font-color">Continue</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="accordion-header p-2 d-flex">
                            <h5 class="mt-2 mr-2">
                                <span class="badge badge-light">2</span>
                            </h5>
                            <h5 class="my-auto">
                                Payment
                            </h5>
                        </div>
                        <footer class="text-center text-lg-start text-muted mt-5">
                            <section class="d-flex justify-content-center justify-content-lg-between border-bottom">
                                <div class="me-5 d-none d-lg-block checkout-font-color">
                                    <span>ⓒ {{ getYear() }} KOA, All rights reserved.</span>
                                </div>
                                <div class="ml-auto pb-4 checkout-font-color">
                                    <span>Terms and Conditions</span> | <span>Privacy Policy</span>
                                </div>
                            </section>
                        </footer>
                    </div>
                </b-col>
                <b-col cols="12" lg="4">
                    <div class="container your-order-section pt-4 px-4">
                        <div class="px-2">
                            <div class="d-flex my-3 checkout-font-color">
                                <h4>Your Order</h4>
                            </div>
                            <div>
                                <div>
                                    <div class="d-flex align-items-center">
                                        <div>
                                            <img
                                                src="~@/assets/checkout/cart-item.svg"
                                                class="rounded item-thumbnail" alt="Shopping item">
                                        </div>
                                        <div class="p-3 mt-3">
                                            <h5 class="small checkout-font-color">Gamma Surfboard</h5>
                                            <p class="mb-0 small checkout-font-color">Color: Black</p>
                                            <p class="mb-0 small checkout-font-color">Dimensions: 5'10" x 18</p>
                                            <p class="small checkout-font-color">Volume: 26.5L</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="divider"></div>
                            <ul class="list-group mt-4 sticky-top">
                                <li class="d-flex justify-content-between">
                                    <div>
                                        <p class="small checkout-font-color">Items</p>
                                    </div>
                                    <span class="text-muted small checkout-font-color">€129.46</span>
                                </li>
                                <li class="d-flex justify-content-between">
                                    <div>
                                        <p class="small checkout-font-color">
                                            Shipping
                                            <font-awesome-icon class="text-muted" icon="exclamation-circle"/>
                                        </p>
                                    </div>
                                    <span class="text-muted small">{{ formattedFee }}</span>
                                </li>
                                <li class="d-flex justify-content-between">
                                    <div>
                                        <p class="small checkout-font-color">
                                            Duties & Taxes
                                            <font-awesome-icon class="text-muted" icon="exclamation-circle"/>
                                        </p>
                                    </div>
                                    <span class="text-muted small checkout-font-color">€3.88</span>
                                </li>
                            </ul>
                            <div class="divider"></div>
                            <div class="mt-3">
                                <li class="d-flex justify-content-between">
                                    <div>
                                        <p class="small font-weight-bold checkout-font-color">
                                            Total
                                        </p>
                                    </div>
                                    <span class="small checkout-font-color">(EUR) <span class="h6 font-weight-bold">{{ formattedTotal }}</span></span>
                                </li>
                            </div>
                            <div>
                                <button type="button" @click="successPage()" class="btn btn-primary continue-button w-100">Continue</button>
                            </div>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import { BCol, BContainer, BFormInput, BRow } from 'bootstrap-vue';
import CollectionPoint from './CollectionPoint.vue';

export default {
    name:"CheckoutView",
    components: {
        BContainer,
        BRow,
        BCol,
        BFormInput,
        CollectionPoint
    },
    data() {
        return {
            selected: null,
            selected_date: null,
            prices: {
                'standard': 7.90,
                'same_day': 15.90,
                'choose_date': 10.90,
                'pick_up': 0.00,
            },
            dates: {
                0: {
                    id: 12,
                    date_day: '12 Fri',
                    month: 'March'
                },
                1: {
                    id: 16,
                    date_day: '16 Tue',
                    month: 'March'
                },
                2: {
                    id: 17,
                    date_day: '17 Wed',
                    month: 'March'
                },
                3: {
                    id: 18,
                    date_day: '18 Thu',
                    month: 'March'
                },
                4: {
                    id: 19,
                    date_day: '19 Fri',
                    month: 'March'
                },
            },
            total: 0,
            delivery_fee: 0
        }
    },
    computed: {
        formattedFee: function() {
            var formatter = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'EUR',
                minimumFractionDigits: 2
            });
            return formatter.format(this.delivery_fee);
        },
        formattedTotal: function() {
            const total = this.delivery_fee + 129.46 + 3.88

            var formatter = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'EUR',
                minimumFractionDigits: 2
            });
            return formatter.format(total);
        }
    },
    methods: {
        selectPayment(option) {
            if(option === this.selected) {
                this.selected = null
            } else {
                this.delivery_fee = this.prices[option]
                this.selected = option
            }
        },
        selectDate(id) {
            if(id === this.selected_date) {
                this.selected_date = null
            } else {
                this.selected_date = id
            }
        },
        getYear() {
            const d = new Date();
            return d.getFullYear();
        },
        successPage() {
            this.$emit('to-success-page');
        }
    }
}
</script>

<style scoped>
    .dynamic-checkout-container {
        font-family: "OpenSans";
        margin-top: 75px;
    }

    .accordion-header-selected {
        background-color: #F8FAFC;
        border-top: 1px solid #CDD4DD;
        border-bottom: 1px solid #CDD4DD;
    }

    .accordion-header-selected span {
        color: #ffffff;
        border-radius: 50%;
        padding: 0.7rem 0.95rem 0.7rem 0.95rem;
        background-color: #FF6E88;
        margin-top: -50px;
    }

    .accordion-header {
        background-color: #F8FAFC;
        border-top: 1px solid #CDD4DD;
        border-bottom: 1px solid #CDD4DD;
    }

    .accordion-header span {
        color: #ffffff;
        border-radius: 50%;
        padding: 0.7rem 0.95rem 0.7rem 0.95rem;
        background-color: #000000;
        margin-top: -50px;
    }

    .delivery-method {
        background-color: #FFEFF2;
    }

    .custom-delivery-radio {
        border: 1px solid #E3E8EF;
        cursor: pointer;
    }

    .custom-delivery-radio:hover {
        background-color:#FFFDFD;
        border: 1px solid #FF6E88;
        cursor: pointer;
    }

    .radio-extension {
        background-color:#FFFDFD;
        border: 1px solid #FF6E88;
        border-top: none;
        border-bottom-right-radius: 0.3rem;
        border-bottom-left-radius: 0.3rem;
    }

    .select-dots{
        height: 20px;
        width: 20px;
        background: #ffffff;
        border-radius: 50%;
        position: relative;
        transition: all 0.3s ease;
    }

    .hidden-dot{
        height: 20px;
        width: 20px;
        padding: 3px;
        background: #FFFDFD;
        border-radius: 50%;
        border: 1px solid #FFFDFD;
    }

    .dot-border {
        padding: 3px;
        border: 1px solid #443853;
        border-radius: 50%;
    }

    .dot-border-hidden {
        padding: 3px;
        border: 1px solid #FFFDFD;
        border-radius: 50%;
    }

    .selected-dots {
        height: 20px;
        width: 20px;
        padding: 2px 2px 2px 2px;
        background: #FF6E88;
        border-radius: 50%;
        position: relative;
        transition: all 0.3s ease;
    }

    .selected-dots-two {
        height: 20px;
        width: 20px;
        padding: 2px 2px 2px 2px;
        background: #FF6E88;
        border-radius: 50%;
        position: relative;
        transition: all 0.3s ease;
        border-bottom: none;
    }

    .selected-radio {
        background-color:#FFFDFD;
        border: 1px solid #FF6E88;
    }

    .selected-radio-two {
        background-color:#FFFDFD;
        border: 1px solid #FF6E88;
        border-bottom: none;
        border-bottom-right-radius: 0px;
        border-bottom-left-radius: 0px;
        border-top-right-radius: 0.3rem;
        border-top-left-radius: 0.3rem;
    }

    .selected-radio-two:hover {
        background-color:#FFFDFD;
        border: 1px solid #FF6E88;
        border-bottom: none;
        border-bottom-right-radius: 0px;
        border-bottom-left-radius: 0px;
        border-top-right-radius: 0.3rem;
        border-top-left-radius: 0.3rem;
    }

    .slide-down-enter-active, .slide-down-leave-active {
        transition: all 0.5s ease;
    }
    .slide-down-enter, .slide-down-leave-to {
        opacity: 0;
        transform: translateY(-20px);
    }

    .radio-date-picker {
        cursor: pointer;
        border: 1px solid #E3E8EF;
    }

    .radio-date-picker:hover {
        border: 1px solid #FF6E88;
    }

    .selected-radio-date-picker {
        cursor: pointer;
        border: 1px solid #FF6E88;
    }

    .your-order-section {
        background-color: #F8FAFC;
        height: calc(100vh - 75px);
        max-height: calc(100vh - 75px);
    }

    .fixed-section {
        position: fixed;
        overflow-y: auto;
    }

    .scroll-section {
        overflow-y: scroll;
        -ms-overflow-style: none;  /* IE and Edge */
        scrollbar-width: none;
        max-height: calc(100vh - 75px);
        position: relative;
    }

    .scroll-section::-webkit-scrollbar {
        display: none;
    }

    .item-thumbnail {
        background-color: #FFE2E7;
        height: 100px;
        width: 100px;
    }

    .divider {
        border-top: 1px solid #D5DCE3;
    }

    .continue-button {
        background-color: #443853;
        font-weight: bold;
        font-size: 0.7rem;
        padding-top: 0.8rem;
        padding-bottom: 0.8rem;
        border-radius: 10px;
        border: 0px solid #D5DCE3;
    }

    .continue-button:hover {
        background-color: #FF6E88;
        font-weight: bold;
        font-size: 0.7rem;
        padding-top: 0.8rem;
        padding-bottom: 0.8rem;
        border-radius: 10px;
        border: 0px solid #D5DCE3;
    }
</style>